import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { PriceConfig } from './components/PriceConfig';
import { PaymentPage } from './components/PaymentPage';
import { PriceProvider } from './contexts/PriceContext';
import { EmailProvider } from './contexts/EmailContext';
export function AppRouter() {
  return <BrowserRouter data-id="element-34">
      <PriceProvider data-id="element-35">
        <EmailProvider data-id="element-36">
          <Routes data-id="element-37">
            <Route path="/" element={<App data-id="element-39" />} data-id="element-38" />
            <Route path="/config" element={<PriceConfig data-id="element-41" />} data-id="element-40" />
            <Route path="/pay/:invoiceId" element={<PaymentPage data-id="element-43" />} data-id="element-42" />
          </Routes>
        </EmailProvider>
      </PriceProvider>
    </BrowserRouter>;
}